type SvgIconProps = React.SVGProps<SVGSVGElement> & { className?: string };

const SvgIcons = {
  wechat: ({ className, ...props }: SvgIconProps) => (
    <svg className={className} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="#57bf6b"
        d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213c0 .163.13.295.29.295a.33.33 0 0 0 .167-.054l1.903-1.114a.86.86 0 0 1 .717-.098a10.2 10.2 0 0 0 2.837.403c.276 0 .543-.027.811-.05c-.857-2.578.157-4.972 1.932-6.446c1.703-1.415 3.882-1.98 5.853-1.838c-.576-3.583-4.196-6.348-8.596-6.348M5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178a1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18m5.34 2.867c-1.797-.052-3.746.512-5.28 1.786c-1.72 1.428-2.687 3.72-1.78 6.22c.942 2.453 3.666 4.229 6.884 4.229c.826 0 1.622-.12 2.361-.336a.72.72 0 0 1 .598.082l1.584.926a.3.3 0 0 0 .14.047c.134 0 .24-.111.24-.247c0-.06-.023-.12-.038-.177l-.327-1.233a.6.6 0 0 1-.023-.156a.49.49 0 0 1 .201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-6.656-6.088V8.89c-.135-.01-.27-.027-.407-.03zm-2.53 3.274c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983a.976.976 0 0 1-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983a.976.976 0 0 1-.969-.983c0-.542.434-.982.969-.982"
      />
    </svg>
  ),
  google: ({ className, ...props }: SvgIconProps) => (
    <svg className={className} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 262">
      <path
        fill="#4285F4"
        d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622l38.755 30.023l2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
      />
      <path
        fill="#34A853"
        d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055c-34.523 0-63.824-22.773-74.269-54.25l-1.531.13l-40.298 31.187l-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
      />
      <path
        fill="#FBBC05"
        d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82c0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602z"
      />
      <path
        fill="#EB4335"
        d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0C79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
      />
    </svg>
  ),
  gunziai: ({ className, ...props }: SvgIconProps) => (
    <svg
      {...props}
      className={className}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="128" height="128" rx="36.7255" fill="#090017" />
      <rect
        width="128"
        height="128"
        rx="36.7255"
        fill="url(#paint0_radial_1545_316)"
        fillOpacity="0.2"
      />
      <rect
        width="128"
        height="128"
        rx="36.7255"
        fill="url(#paint1_radial_1545_316)"
        fillOpacity="0.3"
      />
      <rect
        width="128"
        height="128"
        rx="36.7255"
        fill="url(#paint2_radial_1545_316)"
        fillOpacity="0.6"
      />
      <rect width="128" height="128" rx="36.7255" fill="url(#paint3_radial_1545_316)" />
      <path
        d="M63.2188 34.4561C79.7417 34.4562 93.1357 47.8511 93.1357 64.374C93.1356 80.8968 79.7415 94.2908 63.2188 94.291C55.951 94.291 49.289 91.6989 44.1055 87.3896C65.463 83.9103 79.1093 75.0006 85.9053 70.0313C73.5846 76.6911 42.0877 83.5879 41.7344 83.5879L40.9004 84.2939C36.1753 79.0038 33.3009 72.0253 33.3008 64.374C33.3008 47.851 46.6957 34.4561 63.2188 34.4561ZM67.7803 37.7988C69.3395 42.8452 67.4714 48.3418 63.1592 51.3936C68.2259 49.9434 73.6287 51.95 76.5215 56.3564L76.9668 57.0342L76.7266 56.2578C75.1672 51.2114 77.0355 45.7149 81.3477 42.6631C76.2812 44.1131 70.8792 42.1063 67.9863 37.7002L67.541 37.0215L67.7803 37.7988Z"
        fill="white"
      />
      <path
        d="M112.2 48.9436C111.093 43.9269 101.219 42.3351 87.2256 44.0643C95.1162 43.5939 100.355 44.786 101.006 47.7366C102.275 53.4857 85.6446 63.7334 63.8626 70.6259C42.0806 77.5184 23.3947 78.4455 22.1264 72.6963C21.6838 70.6891 23.4239 68.1352 26.802 65.3655C18.8292 70.624 14.3391 75.7844 15.1897 79.6408C16.9182 87.4761 40.0361 86.9563 66.8248 78.4795C93.6137 70.0027 113.929 56.7789 112.2 48.9436Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1545_316"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-0.903957 54.6014) scale(62.6779 139.549)"
        >
          <stop stopColor="#BFDCFF" />
          <stop offset="1" stopColor="#BFDCFF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_1545_316"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-26.6848 -82.6396 103.476 -29.5982 98.3503 119.565)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_1545_316"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0.253108 -46.953 65.3519 0.937541 1.15706 131.834)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AB5DFF" />
          <stop offset="1" stopColor="#AB5DFF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_1545_316"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-56.6238 -105.488 48.3405 -69.0545 68.2667 157.986)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AB5DFF" />
          <stop offset="1" stopColor="#7800FF" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  ),
  mcp: ({ className, ...props }: SvgIconProps) => (
    <svg
      viewBox="0 0 195 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M25 97.8528L92.8823 29.9706C102.255 20.598 117.451 20.598 126.823 29.9706V29.9706C136.196 39.3431 136.196 54.5391 126.823 63.9117L75.5581 115.177"
        stroke="currentColor"
        strokeWidth="12"
        strokeLinecap="round"
      />
      <path
        d="M76.2653 114.47L126.823 63.9117C136.196 54.5391 151.392 54.5391 160.765 63.9117L161.118 64.2652C170.491 73.6378 170.491 88.8338 161.118 98.2063L99.7248 159.6C96.6006 162.724 96.6006 167.789 99.7248 170.913L112.331 183.52"
        stroke="currentColor"
        strokeWidth="12"
        strokeLinecap="round"
      />
      <path
        d="M109.853 46.9411L59.6482 97.1457C50.2757 106.518 50.2757 121.714 59.6482 131.087V131.087C69.0208 140.459 84.2168 140.459 93.5894 131.087L143.794 80.8822"
        stroke="currentColor"
        strokeWidth="12"
        strokeLinecap="round"
      />
    </svg>
  ),
  gunziaiFull: ({ className, ...props }: SvgIconProps) => (
    <svg
      className={className}
      {...props}
      viewBox="0 0 734 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M720.287 114.617H704.363L718.04 46.2344H733.963L720.287 114.617Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M700.187 114.617H684.361L681.137 99.9639H649.29L640.4 114.617H623.5L667.754 46.2344H683.384L700.187 114.617ZM672.736 61.5717L656.617 87.9481H678.5L672.736 61.5717Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M591.421 62.0589H605.977L597.282 105.824C595.328 115.723 591.551 122.952 585.95 127.511C580.414 132.07 572.99 134.35 563.677 134.35C558.597 134.35 553.908 133.763 549.609 132.591C545.376 131.419 541.729 129.693 538.668 127.414L545.897 116.375C547.981 118.133 550.651 119.501 553.908 120.478C557.229 121.52 560.713 122.041 564.361 122.041C569.506 122.041 573.413 120.901 576.083 118.621C578.754 116.407 580.577 113.021 581.554 108.462L581.945 106.215C577.712 110.122 572.371 112.076 565.924 112.076C561.56 112.076 557.62 111.197 554.103 109.439C550.586 107.615 547.786 105.043 545.702 101.721C543.683 98.3996 542.673 94.492 542.673 89.9982C542.673 84.6578 543.943 79.8059 546.483 75.4424C549.023 71.0789 552.507 67.6272 556.936 65.0873C561.43 62.5473 566.445 61.2773 571.98 61.2773C576.083 61.2773 579.665 62.0589 582.726 63.6219C585.852 65.1198 588.197 67.4644 589.76 70.6556L591.421 62.0589ZM570.027 99.5719C574.455 99.5719 578.102 98.1391 580.968 95.2735C583.833 92.4079 585.266 88.7283 585.266 84.2345C585.266 81.0433 584.224 78.5359 582.14 76.7124C580.056 74.8237 577.158 73.8794 573.446 73.8794C568.952 73.8794 565.24 75.3122 562.309 78.1777C559.443 81.0433 558.011 84.723 558.011 89.2167C558.011 92.4079 559.085 94.9479 561.234 96.8366C563.384 98.6601 566.314 99.5719 570.027 99.5719Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M517.534 61.2773C523.395 61.2773 528.052 62.8404 531.503 65.9665C534.955 69.0274 536.681 73.4235 536.681 79.1546C536.681 81.3038 536.453 83.4204 535.997 85.5045L530.136 114.616H514.896L520.562 86.4814C520.823 85.3742 520.953 84.1694 520.953 82.8669C520.953 80.1315 520.204 78.0475 518.706 76.6147C517.208 75.1819 514.961 74.4655 511.965 74.4655C508.058 74.4655 504.802 75.6052 502.196 77.8847C499.657 80.099 497.931 83.453 497.019 87.9467L491.744 114.616H476.504L486.957 62.0589H501.415L500.243 67.7249C504.932 63.4265 510.695 61.2773 517.534 61.2773Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M465.295 114.617H450.153L460.605 62.0592H475.747L465.295 114.617ZM470.765 54.7325C468.16 54.7325 466.011 53.9835 464.318 52.4856C462.69 50.9225 461.875 49.0339 461.875 46.8196C461.875 44.2145 462.787 42.0653 464.611 40.372C466.499 38.6136 468.942 37.7344 471.938 37.7344C474.608 37.7344 476.757 38.4833 478.385 39.9812C480.078 41.414 480.925 43.205 480.925 45.3542C480.925 48.1547 479.981 50.4341 478.092 52.1925C476.203 53.8858 473.761 54.7325 470.765 54.7325Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M438.092 42.1328H453.332L438.874 114.619H424.415L425.49 109.344C421.061 113.381 415.688 115.4 409.371 115.4C405.268 115.4 401.491 114.456 398.039 112.567C394.587 110.679 391.82 107.976 389.735 104.459C387.717 100.877 386.707 96.6765 386.707 91.8571C386.707 86.0608 387.977 80.8507 390.517 76.2267C393.122 71.5375 396.639 67.8904 401.068 65.2854C405.496 62.6152 410.381 61.2801 415.721 61.2801C419.564 61.2801 422.918 61.9313 425.783 63.2339C428.714 64.5364 431.026 66.4577 432.719 68.9976L438.092 42.1328ZM414.06 102.798C417.056 102.798 419.726 102.082 422.071 100.649C424.415 99.1513 426.239 97.0998 427.542 94.4947C428.844 91.8897 429.495 88.8938 429.495 85.5072C429.495 81.9253 428.421 79.0922 426.272 77.0082C424.188 74.9241 421.257 73.8821 417.479 73.8821C414.484 73.8821 411.813 74.6311 409.469 76.129C407.124 77.5618 405.301 79.5807 403.998 82.1858C402.696 84.7908 402.044 87.7867 402.044 91.1733C402.044 94.7552 403.086 97.5882 405.171 99.6723C407.32 101.756 410.283 102.798 414.06 102.798Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M374.224 114.619H358.984L373.443 42.1328H388.682L374.224 114.619Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M347.767 114.62H332.625L343.078 62.0625H358.22L347.767 114.62Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M316.691 62.0625H331.931L321.478 114.62H307.02L308.095 108.954C305.815 111.103 303.21 112.731 300.279 113.838C297.349 114.88 294.255 115.401 290.999 115.401C285.268 115.401 280.676 113.838 277.224 110.712C273.838 107.586 272.145 103.19 272.145 97.524C272.145 95.3748 272.373 93.2582 272.828 91.1742L278.592 62.0625H293.832L288.263 90.1973C288.003 91.4347 287.873 92.7046 287.873 94.0072C287.873 99.4778 290.803 102.213 296.665 102.213C300.507 102.213 303.666 101.106 306.141 98.8917C308.681 96.6122 310.407 93.2257 311.318 88.7319L316.691 62.0625Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M255.184 79.3513C258.115 80.5236 260.362 82.282 261.925 84.6266C263.553 86.906 264.367 89.7065 264.367 93.028C264.367 100.127 261.566 105.5 255.966 109.147C250.365 112.794 242.908 114.617 233.594 114.617H197.742L211.419 46.2344H244.438C251.797 46.2344 257.463 47.602 261.436 50.3374C265.409 53.0076 267.395 56.85 267.395 61.8648C267.395 66.0329 266.288 69.6149 264.074 72.6107C261.925 75.5414 258.961 77.7883 255.184 79.3513ZM224.705 58.1526L221.481 74.2714H237.6C241.768 74.2714 244.992 73.4574 247.271 71.8292C249.616 70.1359 250.788 67.7262 250.788 64.6001C250.788 60.3018 247.434 58.1526 240.726 58.1526H224.705ZM234.571 102.699C239 102.699 242.452 101.853 244.927 100.159C247.401 98.466 248.639 96.0238 248.639 92.8326C248.639 88.1434 245.22 85.7989 238.381 85.7989H219.234L215.913 102.699H234.571Z"
        fill="var(--color-foreground)"
      />
      <path
        d="M355.348 27.7353C355.811 26.8388 357.096 26.8388 357.262 27.7353L357.364 28.2907C358.287 33.282 361.374 37.3407 365.896 39.5086L366.049 39.5821C366.786 39.9354 366.602 41.0497 365.748 41.403L365.57 41.4765C360.331 43.6444 355.902 47.703 353.329 52.6944L353.043 53.2497C352.581 54.1463 351.295 54.1463 351.13 53.2497L351.027 52.6944C350.104 47.703 347.018 43.6444 342.495 41.4765L342.342 41.403C341.605 41.0497 341.789 39.9354 342.643 39.5821L342.821 39.5086C348.06 37.3407 352.489 33.282 355.062 28.2907L355.348 27.7353Z"
        fill="#090017"
      />
      <path
        d="M355.348 27.7353C355.811 26.8388 357.096 26.8388 357.262 27.7353L357.364 28.2907C358.287 33.282 361.374 37.3407 365.896 39.5086L366.049 39.5821C366.786 39.9354 366.602 41.0497 365.748 41.403L365.57 41.4765C360.331 43.6444 355.902 47.703 353.329 52.6944L353.043 53.2497C352.581 54.1463 351.295 54.1463 351.13 53.2497L351.027 52.6944C350.104 47.703 347.018 43.6444 342.495 41.4765L342.342 41.403C341.605 41.0497 341.789 39.9354 342.643 39.5821L342.821 39.5086C348.06 37.3407 352.489 33.282 355.062 28.2907L355.348 27.7353Z"
        fill="url(#paint0_radial_3486_7491)"
        fillOpacity="0.6"
      />
      <path
        d="M355.348 27.7353C355.811 26.8388 357.096 26.8388 357.262 27.7353L357.364 28.2907C358.287 33.282 361.374 37.3407 365.896 39.5086L366.049 39.5821C366.786 39.9354 366.602 41.0497 365.748 41.403L365.57 41.4765C360.331 43.6444 355.902 47.703 353.329 52.6944L353.043 53.2497C352.581 54.1463 351.295 54.1463 351.13 53.2497L351.027 52.6944C350.104 47.703 347.018 43.6444 342.495 41.4765L342.342 41.403C341.605 41.0497 341.789 39.9354 342.643 39.5821L342.821 39.5086C348.06 37.3407 352.489 33.282 355.062 28.2907L355.348 27.7353Z"
        fill="url(#paint1_radial_3486_7491)"
      />
      <rect width="160" height="160" rx="45.9069" fill="#090017" />
      <rect
        width="160"
        height="160"
        rx="45.9069"
        fill="url(#paint2_radial_3486_7491)"
        fillOpacity="0.2"
      />
      <rect
        width="160"
        height="160"
        rx="45.9069"
        fill="url(#paint3_radial_3486_7491)"
        fillOpacity="0.3"
      />
      <rect
        width="160"
        height="160"
        rx="45.9069"
        fill="url(#paint4_radial_3486_7491)"
        fillOpacity="0.6"
      />
      <rect width="160" height="160" rx="45.9069" fill="url(#paint5_radial_3486_7491)" />
      <path
        d="M79.0225 43.0703C99.6761 43.0705 116.419 59.8141 116.419 80.4678C116.419 101.121 99.676 117.864 79.0225 117.864C69.9379 117.864 61.6103 114.624 55.1309 109.237C81.8278 104.888 98.886 93.7507 107.381 87.5391C91.9801 95.8639 52.6087 104.484 52.167 104.484L51.1231 105.368C45.217 98.7555 41.6251 90.0316 41.625 80.4678C41.625 59.814 58.3687 43.0703 79.0225 43.0703ZM84.7247 47.248C86.6738 53.556 84.3384 60.4264 78.9483 64.2412C85.2815 62.4288 92.0345 64.9374 95.6504 70.4453L96.2071 71.293L95.9073 70.3223C93.958 64.0141 96.2932 57.1429 101.684 53.3281C95.3504 55.1408 88.5975 52.6329 84.9815 47.125L84.4249 46.2773L84.7247 47.248Z"
        fill="white"
      />
      <path
        d="M140.252 61.1806C138.868 54.9095 126.524 52.9198 109.032 55.0815C118.896 54.4934 125.445 55.983 126.259 59.6712C127.844 66.8576 107.057 79.6686 79.8296 88.2842C52.6021 96.8999 29.2441 98.058 27.6587 90.8716C27.1053 88.363 29.2798 85.1711 33.5008 81.7097C23.5367 88.2822 17.9249 94.7316 18.988 99.5517C21.1487 109.346 50.0462 108.696 83.5321 98.0999C117.018 87.504 142.412 70.9748 140.252 61.1806Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3486_7491"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(3.88649 -27.2357 33.4319 -0.353798 337.977 56.9091)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AB5DFF" />
          <stop offset="1" stopColor="#AB5DFF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3486_7491"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-7.94646 -25.5292 13.151 -16.7119 351.352 63.2381)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AB5DFF" />
          <stop offset="1" stopColor="#7800FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3486_7491"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.12995 68.2517) scale(78.3473 174.436)"
        >
          <stop stopColor="#BFDCFF" />
          <stop offset="1" stopColor="#BFDCFF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3486_7491"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-33.3559 -103.3 129.345 -36.9977 122.938 149.456)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_3486_7491"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0.316385 -58.6913 81.6899 1.17193 1.44633 164.793)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AB5DFF" />
          <stop offset="1" stopColor="#AB5DFF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_3486_7491"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-70.7797 -131.86 60.4256 -86.3182 85.3334 197.483)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AB5DFF" />
          <stop offset="1" stopColor="#7800FF" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  ),
  //   mcp: ({ className, ...props }: SvgIconProps) => (
  //     <svg
  //       fill="currentColor"
  //       fill-rule="evenodd"
  //       height="1em"
  //       style="flex:none;line-height:1"
  //       viewBox="0 0 24 24"
  //       width="1em"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <title>ModelContextProtocol</title>
  //       <path d="M15.688 2.343a2.588 2.588 0 00-3.61 0l-9.626 9.44a.863.863 0 01-1.203 0 .823.823 0 010-1.18l9.626-9.44a4.313 4.313 0 016.016 0 4.116 4.116 0 011.204 3.54 4.3 4.3 0 013.609 1.18l.05.05a4.115 4.115 0 010 5.9l-8.706 8.537a.274.274 0 000 .393l1.788 1.754a.823.823 0 010 1.18.863.863 0 01-1.203 0l-1.788-1.753a1.92 1.92 0 010-2.754l8.706-8.538a2.47 2.47 0 000-3.54l-.05-.049a2.588 2.588 0 00-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 01-1.204 0 .823.823 0 010-1.18l7.273-7.133a2.47 2.47 0 00-.003-3.537z"></path>
  //       <path d="M14.485 4.703a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a4.115 4.115 0 000 5.9 4.314 4.314 0 006.016 0l7.12-6.982a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a2.588 2.588 0 01-3.61 0 2.47 2.47 0 010-3.54l7.12-6.982z"></path>
  //     </svg>
  //   ),
  coze: ({ className, ...props }: SvgIconProps) => (
    <svg
      {...props}
      className={className}
      fill="currentColor"
      fillRule="evenodd"
      height="1em"
      style={{ flex: "none", lineHeight: "1" }}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Coze</title>
      <path
        clipRule="evenodd"
        d="M3.908 9.096A8.092 8.092 0 0111.998 1h.006c4.468 0 8.09 3.628 8.09 8.096v3.392h1.942c2.23 0 2.732 3.126.615 3.828l-2.556.85v1.466a1.947 1.947 0 01-2.818 1.742l-1.42-.707c-.067-.03-.149 0-.17.071-1.147 3.587-6.225 3.587-7.373 0a.123.123 0 00-.169-.07l-1.42.706c-1.29.65-2.817-.292-2.817-1.742v-1.466l-2.557-.85c-2.122-.697-1.614-3.828.615-3.828h1.942V9.096zm4.571 2.613a.784.784 0 00-.784.784v1.568a.784.784 0 101.568 0v-1.568a.784.784 0 00-.784-.784zm7.045.779a.784.784 0 100 1.568.784.784 0 000-1.568zm-6.186 3.415a.78.78 0 00.17.254 3.517 3.517 0 004.98 0 .782.782 0 10-1.106-1.107 1.958 1.958 0 01-2.767 0 .78.78 0 00-1.277.254.78.78 0 000 .6z"
      ></path>
    </svg>
  ),
  dify: ({ className, ...props }: SvgIconProps) => (
    <svg
      {...props}
      className={className}
      height="1em"
      style={{ flex: "none", lineHeight: "1" }}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Dify</title>
      <path
        d="M7.043 6.487c1.635 0 2.241-1.003 2.241-2.243S8.681 2 7.044 2C5.405 2 4.801 3.003 4.801 4.244c0 1.24.604 2.243 2.241 2.243z"
        fill="#03F"
      ></path>
      <path
        d="M14.883 6.97v1.443h-3.679v3.203h3.68v8.012H8.801V8.41h-8v3.203h4.48v8.012H0v3.203h24v-3.203h-5.6v-8.012H24V8.41h-5.6V5.206H24V2.003h-4.161a4.97 4.97 0 00-4.961 4.967h.005z"
        fill="#03F"
      ></path>
    </svg>
  ),
  bulb: ({ className, ...props }: SvgIconProps) => (
    <svg
      {...props}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" />
      <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3" />
      <path d="M9.7 17l4.6 0" />
    </svg>
  ),
  puzzle: ({ className, ...props }: SvgIconProps) => (
    <svg
      {...props}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 7h3a1 1 0 0 0 1 -1v-1a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0 -1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 0 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 0 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1" />
    </svg>
  ),
  circleXFilled: ({ className, ...props }: SvgIconProps) => (
    <svg
      {...props}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m3.6 5.2a1 1 0 0 0 -1.4 .2l-2.2 2.933l-2.2 -2.933a1 1 0 1 0 -1.6 1.2l2.55 3.4l-2.55 3.4a1 1 0 1 0 1.6 1.2l2.2 -2.933l2.2 2.933a1 1 0 0 0 1.6 -1.2l-2.55 -3.4l2.55 -3.4a1 1 0 0 0 -.2 -1.4" />
    </svg>
  ),
  circleCheckFilled: ({ className, ...props }: SvgIconProps) => (
    <svg
      {...props}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" />
    </svg>
  ),
};

export default SvgIcons;
